import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class OrderCreate {
  constructor($scope, $filter, UserService, GeoService, OrderService, OfferService) {
    $scope.tabs = ['1. Title & Basic Infos', '2. Delivery Infos', '3. Payment Infos', '4. Necessary Documents'];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.set_buyer_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Buyer', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.order.buyer_id = ui.item.id;
          $scope.order.buyer_user_contact_id = null;
          $scope.buyer_company = ui.item.value;
          $scope.$apply();
          $scope.update_buyer_data(ui.item.id);
        }
      });
    };

    $scope.update_buyer_data = function(user_id) {
      UserService.get_contacts(user_id).success(function(data) {
        $scope.buyer_contacts = data.contacts;
      });
      UserService.get_order_data(user_id).then(function(data) {
        $scope.buyer_incoterms = data.delivery_terms;
        $scope.set_delivery_info();
        $scope.export_docs = angular.copy(window.export_docs);
        angular.forEach(data.export_docs, function(id) {
          var export_doc = _.find($scope.export_docs, function(d) {
            return d.id == id;
          });
          if (export_doc)
            export_doc.checked = true;
        });
      });
    };

    $scope.set_delivery_info = function() {
      if ($scope.buyer_incoterms) {
        var term = _.find($scope.buyer_incoterms, function(t) {
          return t.delivery_term_id == $scope.order.incoterms;
        });
        if (term && term.country_id) {
          $scope.order.delivery_country_id = term.country_id;
        }
        if (term && term.city_id) {
          $scope.order.delivery_city_id = term.city_id;
        }
      }
    };

    $scope.$watch('order.incoterms', function() {
      $scope.set_delivery_info();
    });

    $scope.set_supplier_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Seller', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.order.supplier_id = ui.item.id;
          $scope.order.supplier_user_contact_id = null;
          $scope.supplier_company = ui.item.value;
          $scope.$apply();
          $scope.update_supplier_data(ui.item.id);
        }
      });
    };

    $scope.update_supplier_data = function(user_id) {
      UserService.get_contacts(user_id).success(function(data) {
        $scope.supplier_contacts = data.contacts;
      });
      OfferService.get_offer_ids(user_id).then(function(data) {
        $scope.offer_ids = data.offer_ids;
      });
      UserService.get_order_data(user_id).then(function(data) {
        $scope.order.origin_of_goods = data.origin_of_goods;
        if (data.shipment_country_id)
          $scope.order.shipment_country_id = data.shipment_country_id;
        if (data.shipment_city_id)
          $scope.order.shipment_city_id = data.shipment_city_id;
      });
    };

    $scope.$watch('order.shipment_country_id', function() {
      if ($scope.order.shipment_country_id) {
        GeoService.get_cities($scope.order.shipment_country_id).then(function(data) {
          $scope.shipment_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.order.shipment_city_id}))
            $scope.order.shipment_city_id = null;
        });
      }
    });

    $scope.$watch('order.delivery_country_id', function() {
      if ($scope.order.delivery_country_id) {
        GeoService.get_cities($scope.order.delivery_country_id).then(function(data) {
          $scope.delivery_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.order.delivery_city_id}))
            $scope.order.delivery_city_id = null;
        });
      }
    });

    $scope.create_order = function() {
      $scope.creating_order = true;
      if (!$scope.order.supplier_id) {
        $scope.form_error = 'Please select a supplier!';
        $scope.creating_order = false;
      } else if (!$scope.order.buyer_id) {
        $scope.form_error = 'Please select a buyer!';
        $scope.creating_order = false;
      } else if (!($scope.order.pi_id || $scope.order.oc_id || $scope.order.commercial_invoice)) {
        $scope.form_error = 'Please select PI or OC or Invoice ID!';
        $scope.creating_order = false;
      } else {
        $scope.form_error = '';
        var docs = [];
        angular.forEach($scope.export_docs, function(doc) {
          if (doc.checked)
            docs.push(doc.id);
        });
        $scope.order.export_docs = {
          docs: docs
        };
        OrderService.save($scope.order).then(function(data) {
          if (data.success) {
            $scope.created_order_id = data.order_id;
            $scope.create_mode = false;
          } else {
            $scope.form_error = data.message;
          }
          $scope.creating_order = false;
        });
      }
    };

    $scope.create_new_order = function() {
      $scope.order = angular.copy(window.order);
      $scope.selected_tab = 0;
      $scope.create_mode = true;
      $scope.order.status = 0;
      $scope.order.delivery_status = 0;
      $scope.order.payment_status = 0;
      $scope.order.incoterms = 1;
      $scope.order.delivered_by = 0;
      $scope.buyer_company = '';
      $scope.supplier_company = '';
      $('.supplier_company, .buyer_company').val('');
      $scope.export_docs = angular.copy(window.export_docs);
    };

    $scope.date_options = {
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy'
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.create_mode = true;
      $scope.create_new_order();
      $scope.set_buyer_autocomplete($('input.buyer_company'));
      $scope.set_supplier_autocomplete($('input.supplier_company'));
      $scope.order_statuses = window.order_statuses;
      $scope.delivery_statuses = window.delivery_statuses;
      $scope.payment_statuses = window.payment_statuses;
      $scope.order_incoterms = window.incoterms;
      $scope.order_deliveries = window.deliveries;
    };

    $scope.init();
  }
}

OrderCreate.$inject = ['$scope', '$filter', 'UserService', 'GeoService', 'OrderService', 'OfferService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/order-create.ctrl.js